var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-row',{staticClass:"white-page-bg payment-cb"},[_c('van-col',{attrs:{"span":"24"}},[_c('info-message',{staticClass:"itserve-center place-content-center"},[_c('img',{attrs:{"src":require("@/assets/images/action_success.png"),"alt":"success-action"}}),_c('br'),_vm._v(" "+_vm._s(_vm.$t("pay.paymentSuccessful"))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }